import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteCompanyUserConfiguration } from '../../../../actions';

class CompanyUserConfigurationDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const {
      dispatchDeleteCompanyUserConfiguration,
      companyUserConfigurationId,
    } = this.props;
    dispatchDeleteCompanyUserConfiguration({ companyUserConfigurationId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

CompanyUserConfigurationDeleteButton.propTypes = {
  companyUserConfigurationId: PropTypes.number.isRequired,
  dispatchDeleteCompanyUserConfiguration: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteCompanyUserConfiguration: deleteCompanyUserConfiguration,
};

export default connect(
  null,
  mapDispatchToProps,
)(CompanyUserConfigurationDeleteButton);
